import React, { Component } from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';

class Media extends Component {
	render(props) {
		return (
			<Wrap>
				<video
					ref="video"
					src="https://player.vimeo.com/external/300968770.hd.mp4?s=6f3093aa5cfd1fea0953b8c9d18910c368731e31&profile_id=175"
					poster="https://res.cloudinary.com/ahmadawais/image/upload/f_auto,q_auto/v1542304897/vidplaceholder.jpg"
					onClick={() => {
						const vid = this.refs.video;
						vid.paused ? vid.play() : vid.pause();
					}}
				>
					<track kind="captions" {...props} />
				</video>
			</Wrap>
		);
	}
}

const Wrap = styled.div`
	position: relative;
	background: ${props => props.theme.w};
	border-radius: 0.4rem 0.4rem 0 0;
	padding: 1rem 1rem 0 1rem;
	margin: 10rem auto 0;
	background: ${props => props.theme.gr1};

	${rmq('ls')} {
		display: table;
		width: 80%;
	}
	${rmq('ml')} {
		width: 90%;
		margin: 5rem auto 0;
	}

	video {
		${rmq('ml')} {
			z-index: 1;
		}
	}

	&::before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		box-shadow: 0 16px 48px #a49fc8;
		box-shadow: 0 16px 48px rgba(22, 22, 22, 0.4);
		/* mix-blend-mode: multiply; */
	}

	&::before,
	&::after {
		content: '';
		background: ${props => props.theme.gr2};
		position: absolute;
		width: 105%;
		height: 90%;
		transform: rotateZ(5deg);
		z-index: -1;
		left: -2rem;
		top: 0rem;

		${rmq('ls')} {
			width: 103%;
		}
		${rmq('ml')} {
			z-index: 0;
		}
	}
	&::after {
		transform: rotateZ(-15deg);
		left: -3.5rem;
		top: 3rem;
	}

	video,
	img {
		display: table;
		max-width: 100%;
		width: 100%;
		cursor: pointer;
		position: relative;

		&:hover {
			transform: scale(1.01);
			transition: all 0.4s ease;
			box-shadow: 0 0 12rem 0 rgba(22, 22, 22, 0.4);
		}
	}
`;

export default Media;
